import type { AxiosResponse } from 'axios';

import client from 'api/client';
import type { ClientHistoryParams, ClientHistoryResponse } from 'types';

const DEFAULT_PAGE_SIZE = 50;
const MAX_PAGE_SIZE = 200;

export const get = (
    candidateId: number | string,
    params: ClientHistoryParams = {}
): Promise<AxiosResponse<ClientHistoryResponse>> => {
    const perPage = Math.min(Math.max(params.per_page ?? DEFAULT_PAGE_SIZE, 1), MAX_PAGE_SIZE);

    return client.get<ClientHistoryResponse>(`/clients/${candidateId}/history`, {
        params: {
            page: Math.max(params.page ?? 1, 1),
            per_page: perPage,
        },
    });
};
